import t from 'tcomb';
import UUID from './UUID';

const Captcha = t.struct({
  type: t.Str,
  lattice_id: UUID,
  reducer_id: UUID
}, 'Captcha');

module.exports = Captcha;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Captcha.js
 **/